// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"MaintenanceComponentsList_tabHeader__lzduq"};